
import { DateFormatter, domain, i18n, isAuth, opt } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import * as Prism from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import * as React from 'react';
import { connect } from 'react-redux';
import Editor from 'react-simple-code-editor';
import { isNullOrUndefined } from 'util';
import Rest from '../../webapi/Rest';
import GaranzieActions from '../garanzie/garanzie_actions';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx';
import SwitchButton from '../shared/switchButtonV4.jsx';
import FrazionamentiTable from './FrazionamentiTable.jsx';
import IntermediariTable from './intermediariTable.jsx';
import OperazioniTable from './operazioneTable.jsx';
import PagamentoTable from './PagamentoTable.jsx';
import ProdottoServiziEsterni from './prodottoServiziEsterni.jsx';
import ProdottoSinistri from './prodottoSinistri.jsx';
import ProdottoActions from './prodotto_actions';
import UploadImage from './uploadImage.jsx';
import { ConfirmModalOkCancelV4, ConfirmModalSaveV4, ConfirmModalV4 } from '../shared/v4';
import MicroCategorieActions from './../microCategorie/microCaterogieActions.js';
import microCategorie from '../microCategorie/microCategorieReducer';
import DurataTable from './DurataTable.jsx';
import ScontoTable from './ScontoTable.jsx';
import UploadDocExcel from './uploadDocExcel.jsx';
import app_actions from '../../app/app_actions';
import FirmaDigitale from './firmaDigitale.jsx';
import RegolaProduct from './RegolaProduct.jsx';

class CreateProdotto extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[CreateProdotto.jsx] ';
        this.state = {
            validation: new Map(),
            showConfirm: false,
            showConfirmUpload: false,
            showConfirmDelete: false,
            showConfirmUploadJSON: false,
            showRiscLloyds: false,
            showFlProdottoSoluzione: false,
            showConfirmUploadDoc: false,
            aiDocuments: null,
            showConfirmDeleteDoc: false,
        };
        this.arrayChangeHandler = this.arrayChangeHandler.bind(this);
        this.annullaButton = this.annullaButton.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        // this.state = this.getInitalState();
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.salvaProdotto = this.salvaProdotto.bind(this);
        this.inputChangeHandlerCompagnia = this.inputChangeHandlerCompagnia.bind(this);
        this.checkBoxChangeHandler = this.checkBoxChangeHandler.bind(this);
        this.insertQuota = this.insertQuota.bind(this);
        this.arrayChangeHandlerCompagnie = this.arrayChangeHandlerCompagnie.bind(this);
        this.removeSelectedRow = this.removeSelectedRow.bind(this);
        this.flMandatariaChangeHandler = this.flMandatariaChangeHandler.bind(this);
        this.changeSelectedTab = this.changeSelectedTab.bind(this);
        this.nuovaGaranziaButton = this.nuovaGaranziaButton.bind(this);
        this.showConfirmPanelUpload = this.showConfirmPanelUpload.bind(this);
        this.inputChangeHandlerIntermediario = this.inputChangeHandlerIntermediario.bind(this);
        this.salvaOnClickProdottoCreate = this.salvaOnClickProdottoCreate.bind(this);
        this.showConfirmPanelElimina = this.showConfirmPanelElimina.bind(this);
        this.deleteProdottoImmagine = this.deleteProdottoImmagine.bind(this);
        this.showConfirmPanelUploadJSON = this.showConfirmPanelUploadJSON.bind(this);
        this.showRiscLloyds = this.showRiscLloyds.bind(this);
        this.showFlProdottoSoluzione = this.showFlProdottoSoluzione.bind(this);
        this.showConfirmPanelUploadDoc = this.showConfirmPanelUploadDoc.bind(this);
        this.setDocument = this.setDocument.bind(this);
        this.showConfirmDocumentElimina = this.showConfirmDocumentElimina.bind(this);
        this.deleteDocument = this.deleteDocument.bind(this);
        this.insertAssicurazioneCongiunta = this.insertAssicurazioneCongiunta.bind(this);
        this.arrayChangeHandlerNumeroPolizza = this.arrayChangeHandlerNumeroPolizza.bind(this);
        this.validateFormFirmaDigitale = this.validateFormFirmaDigitale.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');
        this.props.getListaSegnelatori();
        this.props.getListaRamoSinistri();
        let docTariffa = this.props.prodotto.docTariffa;
        if (docTariffa !== null) {
            this.setDocument(docTariffa);
        }

        this.props.inizializzaMicroCategorieProdotto();
        this.props.getListCompagnie();

        if (!this.props.prodotto.id) {
            this.props.changeSelectedTab("home-tab");
        } else {
            let tabCreazione = ['home-tab', 'garanzie-tab',
                'intermediari-tab', 'frazionamenti-tab', , 'durata-tab', 'sconto-tab', 'pagamenti-tab',
                'sinistri-tab', 'regola-tab', 'operazioni-tab', 'servizioEsterno-tab', 'firmaDigitale-tab', 'regolaAnnulli-tab'
            ];

            if (this.props.tabSelected !== undefined && this.props.tabSelected !== null) {

                if (!tabCreazione.includes(this.props.tabSelected)) {
                    this.props.changeSelectedTab("home-tab");
                }
            }
        }

        if (this.props.prodotto != null && this.props.prodotto.flServizioDoPrint == true) {
            this.setState({ showRiscLloyds: this.props.prodotto.flServizioDoPrint });
        }

        if (this.props.prodotto.idMicroCategoria !== null && this.props.prodotto.idMicroCategoria !== undefined) {
            let microCategoria = null;
            this.props.getMicroCategorieDetails(this.props.prodotto.idMicroCategoria).then(
                resolve => {
                    microCategoria = resolve;
                    if (microCategoria !== null && microCategoria !== undefined && microCategoria.microCategoriaPacchetto === true) {
                        this.setState({ showFlProdottoSoluzione: microCategoria.microCategoriaPacchetto });
                    }
                }

            );
            // this.props.getProdottoBaseDetailsdiMicrocategoria(this.props.prodotto.idMicroCategoria);
        }

    }

    annullaButton() {
        if (this.props.location.state && this.props.location.state.modifica) {
            this.props.history.push({ pathname: '/prodotto/details', state: { id: this.props.location.state.id } });
        } else if (this.props.location.state && this.props.location.state.versione) {

            if (this.props.prodottoPadre && this.props.prodottoPadre.id) {
                this.props.history.push({ pathname: '/prodotto/details', state: { id: this.props.prodottoPadre.id } });
            }
        } else if (this.props.location.state && this.props.location.state.clone) {

            this.props.history.push({ pathname: '/prodotto/details', state: { id: this.props.location.state.idProdotto } });
        } else {
            this.props.history.goBack();
        }
    }

    showConfirmPanel() {
        if (!this.state.showConfirm) {
            let validation = false;
            if (this.props.tabSelected === "servizioEsterno-tab") {
                validation = this.validateServizio();
            } else {
                validation = this.validateForm();
            }
            if (!validation) {
                console.log('validateForm return false');
                this.setState({ showConfirm: false });

                return null;
            }
        }
        this.setState({ showConfirm: !this.state.showConfirm });
    }

    inputChangeHandlerIntermediario(index, name, value) {
        this.props.inputChangeHandlerIntermediario(index, name, value).then(
            resolve => {
                this.forceUpdate();

                return resolve;
            }
        )
    }


    validateFormFirmaDigitale() {
        console.log(this.componentName + 'validateFormFirmaDigitale');
        let validation = new Map();
        let nome = ['nomeServizio'];
        let required = ['user', 'url', 'orgId'];
        let requiredMmc = ['tipoAutenticazione', 'url', 'apiKey'];
        for (let i = 0; i < required.length; i++) {

            if (!isNullOrUndefined(this.props.prodottoFirmaDigitale) && this.props.prodottoFirmaDigitale.nomeServizio === "NAMIRIAL") {
                if (required[i] === 'user') {
                    if ((this.props.prodottoFirmaDigitale.user === undefined || this.props.prodottoFirmaDigitale.user === '' || this.props.prodottoFirmaDigitale.user === null)) {
                        validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
                if (required[i] === 'url') {
                    if ((this.props.prodottoFirmaDigitale.url === undefined || this.props.prodottoFirmaDigitale.url === '' || this.props.prodottoFirmaDigitale.url === null)) {
                        validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
                if (required[i] === 'orgId') {
                    if ((this.props.prodottoFirmaDigitale.orgId === undefined || this.props.prodottoFirmaDigitale.orgId === '' || this.props.prodottoFirmaDigitale.orgId === null)) {
                        validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }

            } else if (!isNullOrUndefined(this.props.prodottoFirmaDigitale) && this.props.prodottoFirmaDigitale.nomeServizio === "MMC") {
                if (requiredMmc[i] === 'tipoAutenticazione') {
                    if ((this.props.prodottoFirmaDigitale.tipoAutenticazione === undefined || this.props.prodottoFirmaDigitale.tipoAutenticazione === '' || this.props.prodottoFirmaDigitale.tipoAutenticazione === null)) {
                        validation.set(requiredMmc[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }

                if (requiredMmc[i] === 'url') {
                    if ((this.props.prodottoFirmaDigitale.url === undefined || this.props.prodotto.url === '' || this.props.prodottoFirmaDigitale.url === null)) {
                        validation.set(requiredMmc[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }

                if (requiredMmc[i] === 'apiKey') {
                    if ((this.props.prodottoFirmaDigitale.apiKey === undefined || this.props.prodottoFirmaDigitale.apiKey === '' || this.props.prodottoFirmaDigitale.apiKey === null)) {
                        validation.set(requiredMmc[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
            } else if (!isNullOrUndefined(this.props.prodottoFirmaDigitale) && this.props.prodottoFirmaDigitale.nomeServizio === "") {
                validation.set(nome[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }
        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }

        return false;
    }

    validateForm() {
        console.log(this.componentName + 'validateForm()');
        let validation = new Map();
        let required = ['idMicroCategoria', 'nome', 'idCompagnia', 'idPuntoVendita', 'fineValidita', 'inizioValidita', 'emailCompagnia'];
        for (let i = 0; i < required.length; i++) {
            if (required[i] === 'fineValidita') {
                if (!isNullOrUndefined(this.props.prodotto.inizioValidita) && !isNullOrUndefined(this.props.prodotto.fineValidita)
                    && this.props.prodotto.fineValidita < this.props.prodotto.inizioValidita) {
                    validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.DATA_PRECEDENTE_DALLA_DATA_INIZIO', 'Data Precedente dalla Data inizio'));
                }

                continue;
            }
            if (required[i] === 'emailCompagnia') {
                if (!isNullOrUndefined(this.props.prodotto.emailCompagnia) && this.props.prodotto.emailCompagnia !== "") {
                    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (!re.test(String(this.props.prodotto.emailCompagnia).toLowerCase())) {
                        validation.set(required[i], i18n('QUOTRV2.SHARED.EMAIL', 'Formato non valido'));
                    }
                }
            }

            if (required[i] === 'inizioValidita') {
                if (!isNullOrUndefined(this.props.prodotto.inizioValidita)
                    && !isNullOrUndefined(this.props.prodottoPadre)
                    && !isNullOrUndefined(this.props.prodottoPadre.inizioValidita)
                    && this.props.prodotto.inizioValidita < this.props.prodottoPadre.inizioValidita) {
                    validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.DATA_PRECEDENTE_DALLA_DATA_INIZIO_DEL_PRODOTTO_PADRE', 'Data Precedente dalla Data inizio del Prodotto Padre'));
                }
            }

            if (this.props.prodotto[required[i]] === undefined || this.props.prodotto[required[i]] === null || this.props.prodotto[required[i]] === '') {
                if (required[i] !== 'emailCompagnia' && required[i] !== 'idCompagnia' && required[i] !== 'idPuntoVendita' || ((this.props.prodotto.coass === undefined || this.props.prodotto.coass === null || this.props.prodotto.coass !== true) && (this.props.prodotto.flAssicurazioneCongiunta === undefined || this.props.prodotto.flAssicurazioneCongiunta === null || this.props.prodotto.flAssicurazioneCongiunta !== true)
                    && (this.props.location.state === undefined || this.props.location.state.modifica === false))) {
                    validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                }
            }

            if (required[i] === 'idPuntoVendita' && ((this.props.prodotto.coass === undefined || this.props.prodotto.coass === null || this.props.prodotto.coass !== true) && (this.props.prodotto.flAssicurazioneCongiunta === undefined || this.props.prodotto.flAssicurazioneCongiunta === null || this.props.prodotto.flAssicurazioneCongiunta !== true)
                && (this.props.location.state && this.props.location.state.modifica))) {
                let puntiVendita = this.props.listaPuntiVenditaOfCompagnia;
                let puntoVendita = this.props.prodotto[required[i]];
                if (puntoVendita && puntiVendita) {
                    let pvIndex = puntiVendita.findIndex(pv => pv.id == puntoVendita);
                    if (pvIndex === -1) {
                        validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
            }

            if (required[i] === 'idRischioLloyds' && this.state.showRiscLloyds == true && ((this.props.prodotto.idRischioLloyds === undefined || this.props.prodotto.idRischioLloyds === null || this.props.prodotto.idRischioLloyds === ''))) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            } else if (required[i] === 'idRischioLloyds' && this.state.showRiscLloyds == false) {
                validation.delete('idRischioLloyds');
            }

        }

        this.setState({ validation: validation });

        if (!isNullOrUndefined(this.props.prodotto.percAccessori) && parseInt(this.props.prodotto.percAccessori) < 0) {
            // this.setState({ showConfirm: !this.state.showConfirm });
            return false;
        }

        if (validation.size === 0) {
            return true;
        }

        // $("#modalConfirm").modal("close");
        let firstKey = validation.keys().next().value;

        $('html, body').animate({
            scrollTop: $("#" + firstKey).offset().top - 70
        }, 1000);
        return false;
    }


    arrayChangeHandler(e) {
        // updateI18n
        console.log(this.componentName + 'arrayChangeHandler [index] ');

        let value = e.target.value;
        let index = e.target.id;
        let name = e.target.name;
        if (name != null && name != undefined && name === "idProdottoBase") {
            if (value === "[object Object]") {
                value = null;
            }
        }
        this.props.updateProdottoGaranzia(name, index, value);
        return;
    }

    arrayChangeHandlerCompagnie(e) {
        // updateI18n
        console.log(this.componentName + 'arrayChangeHandlerCompagnie [index] ');
        let value = e.target.value;
        let index = e.target.id;
        let name = e.target.name;

        if (name === "idCompagnia") {
            if (value === "[object Object]") {
                value = "";
            } else {
                this.props.updateItemsPuntoVendita(index, value);
            }
        }

        this.props.updateProdottoCompagnia(name, index, value);
        this.props.calcolaQuaotaCoass();
        // this.setState({ i18n: this.props.i18n })
        return;
    }

    removeSelectedRow(e) {
        let index = e;
        console.log(this.componentName + 'removeSelectedRow' + index);
        if (!isNullOrUndefined(index) && index !== "") {
            if (this.props.location.state && (this.props.location.state.modifica || this.props.location.state.versione || this.props.location.state.clone)) {
                this.props.setFlEliminaCompagnia(index);
            } else {
                this.props.removeSelectedCompagnia(index);
            }
        }
    }

    salvaProdotto() {
        console.log(this.componentName + 'salvaProdotto');

        this.setState({ showConfirm: false });
        if (this.props.location.state && this.props.location.state.clone) {
            let idProdottoSorgente = this.props.location.state.idProdotto;
            this.props.salvaProdotto(this.props.history, true, idProdottoSorgente).then(
                resolve => {

                }, reject => {
                    $('html, body').animate({ scrollTop: 0 }, 1000);
                }
            )
        } else {
            this.props.salvaProdotto(this.props.history).then(
                resolve => {

                }, reject => {
                    $('html, body').animate({ scrollTop: 0 }, 1000);
                }
            )
        }
    }

    flMandatariaChangeHandler(e, id) {
        let value = e.target.value;
        let index = e.target.id;
        console.log(this.componentName + 'inputChangeHandlerCompagnia' + index);
        this.props.updateFlMandataria("flMandataria", index, value);
    }

    flMandatariaChangeHandler(e, id) {
        let value = e.target.value;
        let index = e.target.id;
        console.log(this.componentName + 'inputChangeHandlerCompagnia' + index);
        this.props.updateFlMandataria("flMandataria", index, value);
    }

    inputChangeHandlerCompagnia(e, index) {
        console.log(this.componentName + 'inputChangeHandlerCompagnia' + e.target.id);

        this.inputChangeHandler(e, index);
        if (e.target.value !== undefined && e.target.value !== null && e.target.value !== ""
            && e.target.value !== "[object Object]") {
            this.props.getListaPuntiVenditaOfCompagnia(e.target.value).then(

                resolve => {
                    if (resolve !== null && resolve.length === 1) {
                        this.props.handleChange("idPuntoVendita", resolve[0].id);
                    } else if (resolve === null || resolve.length === 0) {
                        this.props.handleChange("idPuntoVendita", null);
                    }
                },
                reject => {
                    console.log(this.componentName + " getListaPuntiVenditaOfCompagnia(idCompagnia) -> getListaPuntiVenditaOfCompagnia KO");
                }
            );
        }
    }

    inputChangeHandlerProdottoCmp(e, index) {
        if (e !== null && e !== undefined) {

            let value = e.target.value;
            let id = e.target.id;
            console.log(this.componentName + 'checkBoxChangeHandler' + id);
            if (value === "[object Object]") {
                value = "";
            }
            this.props.handleChangeProdottoCmp(id, value);
            this.props.getListCompagnie();
        }
    }
    arrayChangeHandlerNumeroPolizza(e) {
        console.log(this.componentName + 'arrayChangeHandlerNumeroPolizza [index] ');

        let value = e.target.value;
        let index = e.target.id;
        let name = e.target.name;
        if (name != null && name != undefined && name === "numeroPolizza") {
            if (value === "[object Object]") {
                value = null;
            }
        }
        this.props.updateProdottoCmpNumeroPolizza(name, index, value);
        return;
    }

    inputChangeHandler(e) {
        console.log(this.componentName + " inputChangeHandler");
        if (e !== null && e !== undefined) {

            let value = e.target.value;
            let id = e.target.id;
            let type = e.target.type;
            if (value === "[object Object]") {
                value = "";
            }

            if (id === "flServizioDoPrint") {
                this.showRiscLloyds();
            }


            if (id === "idMicroCategoria") {
                let microCategoria = null;
                this.props.getMicroCategorieDetails(value).then(
                    resolve => {
                        microCategoria = resolve;
                        if (microCategoria !== null && microCategoria !== undefined && microCategoria.microCategoriaPacchetto === true) {
                            this.showFlProdottoSoluzione();
                        }
                    }

                );

            }

            if (type === "number" && value === "") {
                value = null;
            }

            if (id == 'idRischioLloyds' && value == '') {
                value = null;
            }

            if (!isNullOrUndefined(type) && type === "radio") {
                id = e.target.name;
            }

            if (this.state.validation.has(id)) {
                this.state.validation.delete(id);
            }

            this.props.handleChange(id, value).then(
                resolve => {
                    if (id === "fineValidita") {

                        this.validateDataFine();
                        if (!isNullOrUndefined(this.props.prodotto.inizioValidita)
                            && this.props.prodotto.fineValidita < this.props.prodotto.inizioValidita) {
                            let validation = new Map();
                            validation.set("fineValidita", i18n('ARM_CORE_PRODUCT.SHARED.DATA_PRECEDENTE_DALLA_DATA_INIZIO', 'Data Precedente dalla Data inizio'));
                            this.setState({ validation: validation })
                        }
                    }
                },
                rejct => {
                    console.log(this.componentName + " handleChange(id, value) -> KO");
                }
            );
        }
    }

    checkBoxChangeHandler(e) {
        if (e !== null && e !== undefined) {
            console.log(this.componentName + 'checkBoxChangeHandler');
            let value = e.target.value;
            let id = e.target.id;
            value = true;
            if (this.props.prodotto.coass) {
                value = false;
            }

            if (this.props.prodotto.flAssicurazioneCongiunta) {
                value = false;
            }
            this.props.handleChange(id, value);
        }
    }

    insertQuota() {
        console.log(this.componentName + 'insertQuota');
        if (this.props.prodotto.quotaCoass !== undefined
            && this.props.prodotto.quotaCoass !== null
            && this.props.prodotto.quotaCoass !== 0) {
            this.props.insertQuota();
        }

        // non si fa update qunado lo stato cambia, quindi faccio una cambia fictiva dello stato per fare reRender.
        this.setState({
            showConfirm: false
        })

    }

    changeSelectedTab(e, index) {
        if (e !== null && e !== undefined) {
            console.log(this.componentName + 'changeSelectedTab' + e.target.id);
            let idTab = e.target.id;
            this.props.changeSelectedTab(idTab);
        }
    }

    nuovaGaranziaButton() {
        console.log(this.componentName + "nuovaGaranziaButton:");

        this.props.inizializzaNuovaGaranziaDalProdotto().then(
            resolve => {
                this.props.history.push({ pathname: '/garanzie/create', state: { prodotto: true } });
            },
            reject => {
                console.log(this.componentName + "nuovaGaranziaButton: KO");
            }
        )
    }

    showConfirmPanelUpload() {
        this.setState({ showConfirmUpload: !this.state.showConfirmUpload })
    }

    showConfirmPanelUploadDoc() {
        this.setState({ showConfirmUploadDoc: !this.state.showConfirmUploadDoc })
    }

    showConfirmPanelUploadJSON() {
        this.setState({ showConfirmUploadJSON: !this.state.showConfirmUploadJSON })
    }

    showConfirmPanelElimina() {
        this.setState({ showConfirmDelete: !this.state.showConfirmDelete })
    }

    showConfirmDocumentElimina() {
        this.setState({ showConfirmDeleteDoc: !this.state.showConfirmDeleteDoc })
    }

    setDocument(document) {
        this.setState({ aiDocuments: document });
    }

    arrayBufferToBase64(buffer) {
        let binary = '';
        let bytes = new Uint8Array(buffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    salvaOnClickProdottoCreate() {
        if (this.props.tabSelected === "provAttive-tab") {
            this.salvaProvAttive()
        } else if (this.props.tabSelected === "servizioEsterno-tab") {
            this.setState({ showConfirm: false });
            this.props.salvaProdottoServiziEsterni(this.props.history);
        } else if (this.props.tabSelected === "firmaDigitale-tab") {
            this.setState({ showConfirm: false });
            if (!this.validateFormFirmaDigitale()) {
                console.log('validateFormFirmaDigitale return false');
                return;
            } else {
                this.props.salvaProdottoFirmaDigitale(this.props.history);
            }
        }
        else {
            this.salvaProdotto();
        }
    }

    validateServizio() {
        console.log(this.componentName + 'validateServizio()');
        let validation = new Map();
        let requiredServEsternoEmissione = ['urlEmissione', 'usernameEmissione', 'passwordEmissione'];
        let requiredServEsternoQuotazione = ['urlQuotazione', 'usernameQuotazione', 'passwordQuotazione'];
        let requiredServEsternoProposta = ['urlProposta', 'usernameProposta', 'passwordProposta'];
        if (this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flEmissioneEsterna) {
            for (let i = 0; i < requiredServEsternoEmissione.length; i++) {
                if (this.props.prodottoServiziEsterni[requiredServEsternoEmissione[i]] === undefined || this.props.prodottoServiziEsterni[requiredServEsternoEmissione[i]] === null || this.props.prodottoServiziEsterni[requiredServEsternoEmissione[i]] === '') {
                    validation.set(requiredServEsternoEmissione[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                }
            }
        }

        if (this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flQuotazioneEsterna) {
            for (let i = 0; i < requiredServEsternoQuotazione.length; i++) {
                if (this.props.prodottoServiziEsterni[requiredServEsternoQuotazione[i]] === undefined || this.props.prodottoServiziEsterni[requiredServEsternoQuotazione[i]] === null || this.props.prodottoServiziEsterni[requiredServEsternoQuotazione[i]] === '') {
                    validation.set(requiredServEsternoQuotazione[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                }
            }
        }

        if (this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flPropostaEsterna) {
            for (let i = 0; i < requiredServEsternoProposta.length; i++) {
                if (this.props.prodottoServiziEsterni[requiredServEsternoProposta[i]] === undefined || this.props.prodottoServiziEsterni[requiredServEsternoProposta[i]] === null || this.props.prodottoServiziEsterni[requiredServEsternoQuotazione[i]] === '') {
                    validation.set(requiredServEsternoProposta[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                }
            }
        }

        this.setState({ validation: validation });

        if (validation.size === 0) {
            return true;
        }

        // $("#modalConfirm").modal("close");
        let firstKey = validation.keys().next().value;

        $('html, body').animate({
            scrollTop: $("#" + firstKey).offset().top - 70
        }, 1000);

        return false;
    }

    deleteProdottoImmagine() {
        this.showConfirmPanelElimina();
        this.props.deleteProdottoImmagine();
    }
    deleteDocument() {
        this.showConfirmDocumentElimina();
        this.props.deleteDocument(this.state.aiDocuments);
        this.props.deleteProdottoDocumentTipoExcel().then(
            resolve => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
                this.setDocument(this.props.prodotto.docTariffa);
            }
        )
    }


    showRiscLloyds() {
        this.setState({ showRiscLloyds: !this.state.showRiscLloyds });
    }


    showFlProdottoSoluzione() {
        this.setState({ showFlProdottoSoluzione: !this.state.showFlProdottoSoluzione });
    }


    downloadDocument() {
        let id = this.state.aiDocuments;
        id = "document/download/" + id;
        this.props.downloadDocument(id);
    }

    insertAssicurazioneCongiunta() {
        //console.log(this.componentName + 'insertAssicurazioneCongiunta');
        if (this.props.prodotto.flAssicurazioneCongiunta === true) {
            this.props.insertAssicurazioneCongiunta();
        }

        // non si fa update qunado lo stato cambia, quindi faccio una cambia fictiva dello stato per fare reRender.
        this.setState({
            showConfirm: false
        })

    }

    render() {
        console.log(this.componentName + 'render');

        let prodottoGaranzia = this.props.prodotto.listaProdottoGaranziaPojo;

        let sinistriList = this.props.prodotto.listSinistri;

        let sinistri = {};
        if (sinistriList !== undefined && sinistriList !== null && sinistriList.length > 0) {
            sinistri = sinistriList[0];
        }

        return (
            <div>
                <agui.aCardV4 className="mt-3 mb-3 inner-card">
                    <agui.aCardV4Header>

                        {this.props.location.state && this.props.location.state.modifica ?
                            <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                {i18n('ARM_CORE_PRODUCT.PRODOTTO.MODIFICA_DE_PRODOTTO', 'Modifica del prodotto')} {this.props.location.state.id}: {this.props.prodotto && this.props.prodotto.nome ? this.props.prodotto.nome : null}
                                {!isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0 &&
                                    <h6 style={
                                        {
                                            color: '#6E6B6B'
                                        }
                                    }> {i18n('ARM_CORE_PRODUCT.PRODOTTO.ATTENZIONE_NON_E_POSSIBILE_MODIFICARE_TUTTI_I_DATI_DEL_PRODOTTO', 'Attenzione: non è possibile modificare tutti i dati del prodotto in quanto risultano delle emissioni già effettuate')}</h6>}
                            </div>
                            :
                            this.props.location.state && this.props.location.state.versione && this.props.prodottoPadre ?
                                <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                    {i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVA_VERSIONE', 'Nuova Versione')}: {this.props.prodottoPadre.nome} Da Versione: {this.props.prodottoPadre.datiVersioneProdotto}
                                </div>
                                :
                                <div style={{ fontSize: "x-large", fontWeight: "bold" }}>
                                    {i18n('ARM_CORE_PRODUCT.PRODOTTO.CREAZIONE_NUOVO_PRODOTTO', 'Creazione Nuovo Prodotto')}
                                </div>
                        }

                    </agui.aCardV4Header>
                    <agui.aCardV4Body>
                        {this.props.location.state && this.props.location.state.modifica &&
                            <ul className="nav nav-tabs" id="myTab" role="tablist">

                                <li className={this.props.tabSelected === "home-tab" ? "active" : "nav-item"} >
                                    <a className={this.props.tabSelected === "home-tab" ? "nav-link active" : "nav-link"} id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO', 'Dettaglio')}</a>
                                </li>
                                {this.props.location.state && this.props.location.state.modifica
                                    && isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_GARANZIE') &&
                                    //  &&
                                    <li className={this.props.tabSelected === "garanzie-tab" ? "active" : "nav-item"}>
                                        <a
                                            className={(!isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0) ? " nav-link disabled" : this.props.tabSelected === "garanzie-tab" ? "nav-link active" : "nav-link"}
                                            // style={{
                                            //     cursor: 'disabled'
                                            // }} title={(!isNullOrUndefined(this.props.prodotto.numEmissioni) || this.props.prodotto.numEmissioni > 0) ? "Non modificabile" : ""} 
                                            id="garanzie-tab" data-toggle="tab" href="#garanzie" role="tab" aria-controls="garanzie" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.MENUTOP.GARANZIE', 'Garanzie')}</a>
                                    </li>}
                                {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_INTERMEDIARI') &&
                                    this.props.location.state && this.props.location.state.modifica &&
                                    <li className={this.props.tabSelected === "intermediari-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "intermediari-tab" ? "nav-link active" : "nav-link"} id="intermediari-tab" data-toggle="tab" href="#intermediari" role="tab" aria-controls="intermediari" aria-selected="true" onClick={this.changeSelectedTab} >{i18n('ARM_CORE_PRODUCT.PRODOTTO.INTERMEDIARI', 'Intermediari')}</a>
                                    </li>}

                                {this.props.location.state && this.props.location.state.modifica &&
                                    isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_FRAZIONAMENTI') &&
                                    <li className={this.props.tabSelected === "frazionamenti-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "frazionamenti-tab" ? "nav-link active" : "nav-link"} id="frazionamenti-tab" data-toggle="tab" href="#frazionamenti" role="tab" aria-controls="frazionamenti" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.FRAZIONAMENTI', 'Frazionamenti')}</a>
                                    </li>}

                                {this.props.location.state && this.props.location.state.modifica &&
                                    opt("APP", "FL_VIEW_TAB_DURATA", "false") === "true" &&
                                    <li className={this.props.tabSelected === "durata-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "durata-tab" ? "nav-link active" : "nav-link"} id="durata-tab" data-toggle="tab" href="#durataA" role="tab" aria-controls="durataA" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DURATA', 'Durata')}</a>
                                    </li>}

                                {this.props.location.state && this.props.location.state.modifica &&
                                    opt("APP", "FL_VIEW_PRODOTTO_TAB_SCONTO", "false") === "true" &&
                                    <li className={this.props.tabSelected === "sconto-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "sconto-tab" ? "nav-link active" : "nav-link"} id="sconto-tab" data-toggle="tab" href="#sconto" role="tab" aria-controls="sconto" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.SCONTO', 'Sconto')}</a>
                                    </li>}

                                {this.props.location.state && this.props.location.state.modifica &&
                                    isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_PAGAMENTI') &&
                                    <li className={this.props.tabSelected === "pagamenti-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "pagamenti-tab" ? "nav-link active" : "nav-link"} id="pagamenti-tab" data-toggle="tab" href="#pagamenti" role="tab" aria-controls="pagamenti" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PAGAMENTI', 'Pagamenti')}</a>
                                    </li>}

                                {this.props.location.state && this.props.location.state.modifica &&
                                    !isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_SINISTRI') &&
                                    <li className={this.props.tabSelected === "sinistri-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "sinistri-tab" ? "nav-link active" : "nav-link"} id="sinistri-tab" data-toggle="tab" href="#sinistri" role="tab" aria-controls="sinistri" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.SINISTRI', 'Sinistri')}</a>
                                    </li>
                                }

                                {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_REGOLA') &&
                                    <li className={this.props.tabSelected === "regola-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "regola-tab" ? "nav-link active" : "nav-link"} id="regola-tab" data-toggle="tab" href="#regola" role="tab" aria-controls="regola" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.REGOLA', 'Regola')}</a>
                                    </li>
                                }
                                {this.props.location.state && this.props.location.state.modifica &&
                                    isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_OPERAZIONI') &&
                                    this.props.prodotto.microCategoria && this.props.prodotto.microCategoria.flFinanziaria &&
                                    <li className={this.props.tabSelected === "operazioni-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "operazioni-tab" ? "nav-link active" : "nav-link"} id="operazioni-tab" data-toggle="tab" href="#operazioni" role="tab" aria-controls="operazioni" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.OPERAZIONI', 'Operazioni')}</a>
                                    </li>}

                                {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_SERVIZIO_ESTERN') &&
                                    this.props.location.state && this.props.location.state.modifica &&
                                    <li className={this.props.tabSelected === "servizioEsterno-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "servizioEsterno-tab" ? "nav-link active" : "nav-link"} id="servizioEsterno-tab" data-toggle="tab" href="#servizioEsterno" role="tab" aria-controls="servizioEsterno" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.SERVIZIOESTERNO', 'Servizio Esterno')}</a>
                                    </li>}

                                {opt("APP", "FIRMA_DIGITALE", "false") === "TRUE" &&
                                    this.props.location.state && this.props.location.state.modifica &&
                                    <li className={this.props.tabSelected === "firmaDigitale-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "firmaDigitale-tab" ? "nav-link active" : "nav-link"} id="firmaDigitale-tab" data-toggle="tab" href="#firmaDigitale" role="tab" aria-controls="firmaDigitale" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.FIRMA_DIGITALE', 'Firma Digitale')}</a>
                                    </li>}

                                {opt("APP", "REGOLA_ANNULLI", "false") === "TRUE" &&
                                    this.props.location.state && this.props.location.state.modifica &&
                                    <li className={this.props.tabSelected === "regolaAnnulli-tab" ? "active" : "nav-item"}>
                                        <a className={this.props.tabSelected === "regolaAnnulli-tab" ? "nav-link active" : "nav-link"} id="regolaAnnulli-tab" data-toggle="tab" href="#regolaAnnulli" role="tab" aria-controls="regolaAnnulli" aria-selected="true" onClick={this.changeSelectedTab}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.REGOLA_ANNULLI', 'Regola Annulli')}</a>
                                    </li>}

                            </ul>}

                        <div className="tab-content" id="myTabContent">
                            <div className={this.props.tabSelected === "home-tab" ? "tab-pane active" : "tab-pane fade"} id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ASelectV4
                                            id="idMicroCategoria"
                                            required={true}
                                            validation={this.state.validation}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler}
                                            value={this.props.prodotto.idMicroCategoria}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.MICRO_CATEGORIA', 'Micro-categoria')}
                                            items={this.props.prodotto.gruppiProdotto}
                                            valueKey="id"
                                            labelKey="nome"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="nome" type="text"
                                            value={this.props.prodotto.nome}
                                            placeholder="inserire nome"
                                            disabled={this.props.location.state && (this.props.location.state.versione
                                                || this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                                            required
                                            label={i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}
                                            validation={this.state.validation}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="nomeVersione" type="text"
                                            value={this.props.prodotto.nomeVersione}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_NOMEVERSIONE', 'inserire nomeVersione')}
                                            required='nomeVersione'
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.NOME_VERSIONE', 'Nome Versione')}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_IDENTIFICATIVO_DELLA_VERSIONE', 'Info: Identificativo della versione, es. anno di validità')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="descrizione" type="text"
                                            maxlength={255}
                                            value={this.props.prodotto.descrizione}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.SHARED.INSERIRE_DESCRIZIONE', 'inserire descrizione')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">

                                        <agui.ATextInputV4 id="inizioValidita" type="date"
                                            value={this.props.prodotto.inizioValidita ? DateFormatter.formatDateFromMilisToString(this.props.prodotto.inizioValidita) : ""}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.DATA_INIZIO_VALIDITA', 'Data Inizio Validità')}
                                            required={true}
                                            validation={this.state.validation}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DATA_INIZIO_VALIDITA', 'Data Inizio Validità')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler} />
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="fineValidita" type="date"
                                            value={this.props.prodotto.fineValidita ? DateFormatter.formatDateFromMilisToString(this.props.prodotto.fineValidita) : ""}
                                            // placeholder="Ins Fine Validità"
                                            validation={this.state.validation}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DATA_FINE_VALIDITA', 'Data Fine Validità')}
                                            onChange={this.inputChangeHandler} />
                                    </div>



                                </div>
                                {this.props.location.state && this.props.location.state.versione &&
                                    <div > <h6> *{i18n('ARM_CORE_PRODUCT.PRODOTTO.STESSA_DATA_VERRA_RIPORTATA_COME_DATA_FINE_VALIDITA_SULLA_VERSIONE_PRECEDENTE_DEL_PRODOTTO', 'La stessa data verrà riportata come data fine validità sulla versione precedente del prodotto.')} </h6> </div>
                                }
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ASelectV4
                                            id="stato"
                                            onChange={this.inputChangeHandler}
                                            value={this.props.prodotto.stato}
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.STATO', 'Stato')}
                                            items={domain("AI_STATO_PRODOTTO")}
                                            valueKey="valCampo"
                                            labelKey="desDom"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id={"ordine"}
                                            type="number"
                                            value={this.props.prodotto.ordine}
                                            validation={this.props.validation}
                                            name="ordine"
                                            label={i18n('ARM_CORE_PRODUCT.SHARED.POSIZIONE', 'Ordine Visibilità')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>
                                <div className="row mt-4">

                                    <div className="col-4 col-sm-4 col-md-4 col-lg-2">
                                        <agui.ATextInputV4 id="percAccessori" type="number"
                                            value={this.props.prodotto.percAccessori}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_ACCESORI', '% Accessori')}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_PERC_ACCESORI', 'Info: % da applicare per il calcolo dell\'importo netto degli accessori')}
                                            minValueAllowed={0}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_ACCESORI', '% Accessori')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-2">
                                        <agui.ATextInputV4 id="accessoriMin" type="number"
                                            value={this.props.prodotto.accessoriMin ? this.props.prodotto.accessoriMin : ""}
                                            validation={this.state.validation}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_PERC_ACCESORI_MIN', 'Info: % minimale da applicare per il calcolo dell\'importo netto degli accessori')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.MIN', 'Min')}
                                            minValueAllowed={0}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-2">
                                        <agui.ATextInputV4 id="accessoriMax" type="number"
                                            value={this.props.prodotto.accessoriMax ? this.props.prodotto.accessoriMax : ""}
                                            validation={this.state.validation}
                                            minValueAllowed={0}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_PERC_ACCESORI_MAX', 'Info: % massimale da applicare per il calcolo dell\'importo netto degli accessori')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.MAX', 'Max')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>

                                <div className="row mt-4">

                                    <div className="col-4 col-sm-4 col-md-4 col-lg-2">
                                        <agui.ATextInputV4 id="specialCharge" type="number"
                                            value={this.props.prodotto.specialCharge ? this.props.prodotto.specialCharge : ""}
                                            // placeholder="Ins Fine Validità"
                                            minValueAllowed={0}
                                            validation={this.state.validation}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SPECIAL_CHARGE', 'Special Charge')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-2">
                                        <agui.ATextInputV4 id="specialChargeMin" type="number"
                                            value={this.props.prodotto.specialChargeMin ? this.props.prodotto.specialChargeMin : ""}
                                            // placeholder="Ins Fine Validità"
                                            validation={this.state.validation}
                                            minValueAllowed={0}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SPECIAL_CHARGE_MIN', 'Min')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-2">
                                        <agui.ATextInputV4 id="specialChargeMax" type="number"
                                            value={this.props.prodotto.specialChargeMax ? this.props.prodotto.specialChargeMax : ""}
                                            // placeholder="Ins Fine Validità"
                                            validation={this.state.validation}
                                            minValueAllowed={0}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SPECIAL_CHARGE_MAX', 'Max')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler} />

                                    </div>


                                    <div className="col-4 col-sm-4 col-md-4 col-lg-2">
                                        {opt("APP", "VIEW_PERC_BONUS", "false") === "true" &&
                                            <agui.ATextInputV4 id="percBonus" type="number"
                                                value={this.props.prodotto.percBonus ? this.props.prodotto.percBonus : ""}
                                                // placeholder="Ins Fine Validità"
                                                validation={this.state.validation}
                                                minValueAllowed={0}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_BONUS', '% Percentuale Bonus')}
                                                disabled={this.props.location.state && this.props.location.state.modifica
                                                    && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                                onChange={this.inputChangeHandler} />
                                        }

                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ASelectV4
                                            id="modalitaCalcoloProvvPassive"
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler}
                                            value={this.props.prodotto.modalitaCalcoloProvvPassive}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.CALCOLO_PROVV_PASSIVE', 'Calcolo Provvigioni Passive')}
                                            items={domain("AI_MODALITA_PROVV_PASSIVE")}
                                            valueKey="valCampo"
                                            labelKey="desDom"
                                        />
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    {/* <div className=" row col-12 col-sm-12 col-md-4 col-lg-4 mr-3"> */}

                                    <SwitchButton
                                        id="flTacitoRinnovo"
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.TACITO_RINNOVO', 'Tacito Rinnovo')}
                                        disabled={this.props.location.state && this.props.location.state.modifica
                                            && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                        value={this.props.prodotto.flTacitoRinnovo === "true" || this.props.prodotto.flTacitoRinnovo === true}
                                        componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                        onChange={this.inputChangeHandler}
                                    />

                                    <SwitchButton
                                        id="flStampaCertificato"
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.STAMPA_CERTIFICATO', 'Stampa Certificato')}
                                        value={this.props.prodotto.flStampaCertificato === "true" || this.props.prodotto.flStampaCertificato === true}
                                        componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                        disabled={this.props.location.state && this.props.location.state.modifica
                                            && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                        onChange={this.inputChangeHandler}
                                    />

                                    {opt("APP", "DO_PRINT", "false") === "TRUE" &&
                                        <SwitchButton
                                            id="flServizioDoPrint"
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SERVIZIO_DO_PRINT', 'Servizio DoPrint')}
                                            value={this.props.prodotto.flServizioDoPrint === "true" || this.props.prodotto.flServizioDoPrint === true}
                                            componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler}
                                        />}

                                    {/* {opt("APP", "FIRMA_DIGITALE", "false") === "TRUE" &&
                                        <SwitchButton
                                            id="flMailFirmaDigitale"
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.FIRMA_DIGITALE', 'Servizio Mail Firma Digitale')}
                                            value={this.props.prodotto.flMailFirmaDigitale === "true" || this.props.prodotto.flMailFirmaDigitale === true}
                                            componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler}
                                        />} */}


                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggDurataMin" type="number"
                                            value={this.props.prodotto.ggDurataMin}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_GIORNI_DURATA_MIN', 'Info: Numero minimo dei giorni di durata  della polizza')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GG_DURATA_MIN', 'inserire ggDurataMin')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DURATA_MIN', 'Giorni Durata Min')}
                                            validation={this.state.validation}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggDurataMax" type="number"
                                            value={this.props.prodotto.ggDurataMax}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_GIORNI_DURATA_MAX', 'Info: Numero massimale dei giorni di durata  della polizza')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DURATA_MAX', 'Giorni Durata Max')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GG_DURATA_MAX', 'inserire ggDurataMax')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ASelectV4
                                            id="modalitaRatino"
                                            onChange={this.inputChangeHandler}
                                            value={this.props.prodotto.modalitaRatino}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.MODALITA_RATINO', 'Modalità Ratino')}
                                            items={domain("AI_MODALITA_RATINO")}
                                            valueKey="valCampo"
                                            labelKey="desDom"
                                        />
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggDecorrezzaMin" type="number"
                                            value={this.props.prodotto.ggDecorrezzaMin}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_GIORNI_DECORRENZA_MIN', 'Info: Numero dei giorni da sommare alla data odierna per calcolare la data effetto minima della polizza in fase di emissione')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GG_DECORRENZA_MIN', 'inserire ggDecorrenzaMin')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MIN', 'Giorni Decorrenza Min')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggDecorrezzaMax" type="number"
                                            value={this.props.prodotto.ggDecorrezzaMax}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MAX', 'Giorni Decorrenza Max')}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_GIORNI_DECORRENZA_MAX', 'Info: Numero dei giorni da sommare alla data odierna per calcolare la data effetto massima della polizza in fase di emissione')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GGDECORRENZAMAX', 'inserire ggDecorrenzaMax')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggRipensamento" type="number"
                                            value={this.props.prodotto.ggRipensamento}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_RIPENSAMENTO_LABEL', 'Giorni Ripensamento')}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_GIORNI_RIPENSAMENTO', 'Info: Numero dei giorni Ripensamento')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_RIPENSAMENTO', 'inserire ggRipensamento')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggDecorrezzaMinRinnovi" type="number"
                                            value={this.props.prodotto.ggDecorrezzaMinRinnovi}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_GIORNI_DECORRENZA_MIN_RINNOVI', 'Info: Numero dei giorni da sommare alla data odierna per calcolare la data effetto minima della polizza in fase di rinnovo')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GG_DECORRENZA_MIN_RINNOVI', 'inserire ggDecorrenzaMinRinnovi')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MIN_RINNOVI', 'Giorni Decorrenza Min Rinnovi')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggDecorrezzaMaxRinnovi" type="number"
                                            value={this.props.prodotto.ggDecorrezzaMaxRinnovi}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_GIORNI_DECORRENZA_MAX_RINNOVI', 'Info: Numero dei giorni da sommare alla data odierna per calcolare la data effetto massima della polizza in fase di rinnovo')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MAX_RINNOVI', 'Giorni Decorrenza Max Rinnovi')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GG_DECORRENZA_MAX_RINNOVI', 'inserire ggDecorrenzaMaxRinnovi')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggMoraEmissione" type="number"
                                            value={this.props.prodotto.ggMoraEmissione}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_MORA_EMISSIONE', 'Giorni Mora Emissione')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GIORNI_MORA_EMISSIONE', 'inserire ggMoraEmissione')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggMoraRinnovo" type="number"
                                            value={this.props.prodotto.ggMoraRinnovo}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GG_MORA_RINNOVO', 'inserire ggMoraRinnovo')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_MORA_RINNOVO', 'Giorni Mora Rinnovo')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="ggDisdettabilita" type="number"
                                            value={this.props.prodotto.ggDisdettabilita}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_GG_DISDETTABILITA', 'inserire ggDisdettabilita')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DISDETTABILITA', 'Giorni disdettabilità')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="nomeFileRegola" type="text"
                                            value={this.props.prodotto.nomeFileRegola}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_FILE_REGOLA', 'inserire Nome File Regola')}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.FILE_REGOLA', 'Nome File Regola')}
                                            onChange={this.inputChangeHandler} />
                                    </div>

                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="numeroPolizzaBase" type="text"
                                            value={this.props.prodotto.numeroPolizzaBase}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.NUMERO_POLIZZA_BASE', 'Numero Polizza Base')}
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler} />
                                    </div>

                                    <SwitchButton
                                        id="flNuovoNumeroRinnovo"
                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVO_NUMERO_POLIZZA_RINNOVO', 'Nuovo numero polizza al rinnovo')}
                                        disabled={this.props.location.state && this.props.location.state.modifica
                                            && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                        value={this.props.prodotto.flNuovoNumeroRinnovo === "true" || this.props.prodotto.flNuovoNumeroRinnovo === true}
                                        componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                        onChange={this.inputChangeHandler}
                                    />

                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="uniqueMarketReference" type="text"
                                            value={this.props.prodotto.uniqueMarketReference}
                                            info={i18n('ARM_CORE_PRODUCT.PRODOTTO.INFO_UMR', "Info : L'UMR, o riferimento di mercato unico, è un riferimento assegnato all'autorità vincolante dal mercato dei Lloyd's")}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.UMR', 'Unique Market Reference (UMR)')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_UMR', 'inserire UMR')}
                                            onChange={this.inputChangeHandler} />
                                    </div>
                                    {this.state.showFlProdottoSoluzione == true ?
                                        <SwitchButton
                                            id="flProdottoSoluzione"
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVO_PRODOTTO_SOLUZIONE', 'Prodotto Soluzione')}
                                            // disabled={this.props.location.state && this.props.location.state.modifica
                                            //     && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            value={this.props.prodotto.flProdottoSoluzione === "true" || this.props.prodotto.flProdottoSoluzione === true}
                                            componentClass="mt-3 col-sm-12 col-md-6 col-lg-6 mb-3"
                                            onChange={this.inputChangeHandler}
                                        />
                                        :
                                        null
                                    }

                                </div>
                                {isAuth("PRODUCT_VIEW_TARIFFE") &&
                                    <div className="row mt-4">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ATextInputV4 id="codProdottoCmp" type="text"
                                                value={this.props.prodotto.codProdottoCmp}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_CMP', 'Codice prodotto compagnia')}
                                                placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_CMP', 'Codice prodotto compagnia')}
                                                onChange={this.inputChangeHandler} />
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ATextInputV4 id="codProdottoBanca" type="text"
                                                value={this.props.prodotto.codProdottoBanca}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_BANCA', 'Codice prodotto banca')}
                                                placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_BANCA', 'Codice prodotto banca')}
                                                onChange={this.inputChangeHandler} />
                                        </div>
                                    </div>
                                }
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ASelectV4
                                            id="codProdottoDiv"
                                            disabled={false}
                                            onChange={this.inputChangeHandler}
                                            value={this.props.prodotto ? this.props.prodotto.codProdottoDiv : null}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.DIVISA', 'Divisa ')}
                                            items={domain('COD_DIVPORT')}
                                            validation={this.state.validation}
                                            valueKey="valCampo"
                                            labelKey="desDom"
                                        />
                                    </div>

                                    {opt("APP", "FL_VIEW_DOC_PRODOTTO_TARIFFA", "false") === "true" && !isNullOrUndefined(this.props.prodotto.id) ?
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <h6>{i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PROD_TARIFFA', 'Prodotto Tariffa')}</h6>
                                            <agui.aButton bs="primary" icon="fas fa-upload" onClick={this.showConfirmPanelUploadDoc} disabled={this.state.aiDocuments !== null}>
                                                {this.state.aiDocuments ?
                                                    i18n('ARM_CORE_PRODUCT.SHARED.UPLOAD', 'Upload')
                                                    : i18n('ARM_CORE_PRODUCT.SHARED.UPLOAD', 'Upload')}
                                            </agui.aButton>

                                            {this.state.aiDocuments ?
                                                <a
                                                    onClick={() => this.downloadDocument()}
                                                    id={this.state.aiDocuments || this.state.aiDocuments.id}
                                                    disabled={true}
                                                    className="badge text-truncate"
                                                    title={i18n('ARM_CORE_PRODUCT.PRODOTTO.TARIFE', 'Prodotto Tarife')}>
                                                    <i style={{ color: "#228B22" }} className={"fas fa-file-excel fa-fw  fa-2x"} />
                                                    {i18n('ARM_CORE_PRODUCT.PRODOTTO.TARIFE', 'Prodotto Tarife')}
                                                </a>
                                                : null
                                            }
                                            {this.state.aiDocuments ?
                                                <agui.aButton bs="danger" className="ml-2" icon="fas fa-trash" onClick={this.showConfirmDocumentElimina}>
                                                    {i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA', 'Elimina')}</agui.aButton>
                                                : null}


                                            <UploadDocExcel idProdotto={this.props.prodotto.id} prodotto={this.props.prodotto} show={this.state.showConfirmUploadDoc} close={this.showConfirmPanelUploadDoc} setDocument={this.setDocument}
                                                inputChangeHandler={this.props.handleChange} />
                                        </div>
                                        : null}

                                </div>
                                <div className="row mt-4">
                                    {isAuth('PRODUCT.VIS_SEGNALATORE') ?
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ASelectV4
                                                id="idOperatoreSegn"
                                                onChange={this.inputChangeHandler}
                                                value={this.props.prodotto.idOperatoreSegn ? this.props.prodotto.idOperatoreSegn : ""}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.SEGNALATORE', 'Segnalatore')}
                                                items={this.props.listaSegnelatori}
                                                valueKey="0"
                                                labelKey="1"
                                            />
                                        </div>
                                        : null}

                                    {isAuth('PRODUCT.VIS_SEGNALATORE') ?
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                                            <agui.ATextInputV4 id="provvigioni" type="number"
                                                value={this.props.prodotto.provvigioni}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.CAMPO_PROVVIGIONI', ' % Provvigioni')}
                                                placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.CAMPO_PROVVIGIONI', '% Provvigioni')}
                                                onChange={this.inputChangeHandler} />
                                        </div>
                                        : null}
                                </div>

                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="codTariffa" type="text"
                                            value={this.props.prodotto.codTariffa}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_TARIFFA', 'Codice Tariffa')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_TARIFFA', 'Codice Tariffa')}
                                            onChange={this.inputChangeHandler} />
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        <agui.ATextInputV4 id="emailCompagnia" type="email"
                                            value={this.props.prodotto.emailCompagnia}
                                            validation={this.state.validation}
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_EMAIL', 'Email  Compagnia')}
                                            placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_EMAILP', 'Enter your email')}
                                            onChange={this.inputChangeHandler} />
                                    </div>

                                </div>





                                {/* Autorizzazione che abilita le operazioni sul prodotto */}
                                {opt("APP", "FL_VIEW_AUTH_ABILITAZIONE", "false") === "true" &&
                                    <div className="row mt-4">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ATextInputV4 id="authAbilitazione" type="text"
                                                value={this.props.prodotto.authAbilitazione}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_AUTH_ABILITAZIONE', 'Auth Abilitazione')}
                                                onChange={this.inputChangeHandler} />
                                        </div>
                                    </div>
                                }


                                <div className="row mt-4">
                                    {opt("APP", "FL_VIEW_ADEGUATEZZA_ESTERNA", "false") === "true" &&
                                        <SwitchButton
                                            id="flAdeguatezzaEsterna"
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.ADEGUATEZZA_ESTERNA', 'Adeguatezza Esterna')}
                                            value={this.props.prodotto.flAdeguatezzaEsterna === "true" || this.props.prodotto.flAdeguatezzaEsterna === true}
                                            componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                            disabled={this.props.location.state && this.props.location.state.modifica
                                                && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                            onChange={this.inputChangeHandler}
                                        />}


                                    {opt("APP", "FL_VIEW_TITOLO_ANTICIPATO", "false") === "true" &&
                                        <>
                                            <SwitchButton
                                                id="flTitoloAnticipato"
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.TITOLO_ANTICIPATO', 'Titolo anticipato')}
                                                disabled={this.props.location.state && this.props.location.state.modifica
                                                    && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                                value={this.props.prodotto.flTitoloAnticipato === "true" || this.props.prodotto.flTitoloAnticipato === true}
                                                componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                                onChange={this.inputChangeHandler}
                                            />

                                            <SwitchButton
                                                id="flIncassoConEffetto"
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.INCASSO_CON_EFFETTO', 'Data incasso coincide con data effetto')}
                                                disabled={this.props.location.state && this.props.location.state.modifica
                                                    && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                                value={this.props.prodotto.flIncassoConEffetto === "true" || this.props.prodotto.flIncassoConEffetto === true}
                                                componentClass="mt-3 col-sm-12 col-md-4 col-lg-3 mb-3"
                                                onChange={this.inputChangeHandler}
                                            />
                                        </>
                                    }
                                </div>

                                {this.state.showRiscLloyds == true ?
                                    <div className="row mt-4">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ASelectV4
                                                id="idRischioLloyds"
                                                disabled={false}
                                                onChange={this.inputChangeHandler}
                                                value={this.props.prodotto ? this.props.prodotto.idRischioLloyds + "" : null}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.RISCHIOLLOYDS', 'Rischio Lloyds ')}
                                                items={domain('LISTA_RISCHIO_LLOYDS')}
                                                validation={this.state.validation}
                                                valueKey="valCampo"
                                                labelKey="desDom"
                                            />
                                        </div>
                                    </div> :
                                    null
                                }

                                <div className="row mt-3 ml-1" style={{ alignItems: "flex-end" }}>
                                    {
                                        this.props.prodotto.imagine ?
                                            <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className="col-12 col-lg-5 col-md-6 col-sm-12 mt-2 "
                                                sizes="50x32" rel="icon" src={this.props.prodotto.imagine ? "data:image/png;base64," + this.arrayBufferToBase64(this.props.prodotto.imagine) : ""} alt="Card image cap" />
                                            : this.props.prodotto.imagePath ?
                                                <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className="col-12 col-lg-5 col-md-6 col-sm-12 mt-2 " sizes="50x32" rel="icon" src={this.props.prodotto.imagePath ? Rest.createRestLink("document/download/" + this.props.prodotto.imagePath) : ""} alt="Card image cap" />
                                                :
                                                <h6 className="mt-2">{i18n('ARM_CORE_PRODUCT.IMAGGE', 'Nessuna immagine legata a questo prodotto')}</h6>
                                    }

                                    <div className="col-4">
                                        <agui.aButton bs="primary" icon="fas fa-upload" onClick={this.showConfirmPanelUpload}>
                                            {this.props.prodotto && this.props.prodotto.imagine ?
                                                i18n('ARM_CORE_PRODUCT.SHARED.CAMBIA', 'Cambia') :
                                                i18n('ARM_CORE_PRODUCT.SHARED.UPLOAD', 'Upload')}</agui.aButton>
                                        {this.props.prodotto.imagePath || this.props.prodotto.imagine ?
                                            <agui.aButton bs="danger" className="ml-2" icon="fas fa-trash" onClick={this.showConfirmPanelElimina}>
                                                {i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA', 'Elimina')}</agui.aButton>
                                            : null
                                        }
                                    </div>
                                </div>
                                <UploadImage idProdotto={this.props.prodotto.id} show={this.state.showConfirmUpload} close={this.showConfirmPanelUpload} inputChangeHandler={this.props.handleChange} />

                                <div className="row mt-3">
                                    <div className="col col-sm-1 col-md-1 col-lg-1">
                                        <agui.aToggleV4
                                            id="coass"
                                            label={i18n('ARM_CORE_PRODUCT.PRODOTTO.COASS', 'Coass')}
                                            type="NO"
                                            disabled=
                                            {(this.props.location.state && (this.props.location.state.modifica || this.props.location.state.versione
                                                || this.props.location.state.clone))}
                                            value={this.props.prodotto.coass}
                                            checked={this.props.prodotto.coass}
                                            onChange={this.checkBoxChangeHandler}
                                        />
                                    </div>
                                </div>

                                {opt("APP", "FL_VIEW_ASSICURAZIONE_CONGIUNTA", "false") === "true" &&
                                    <div className="row mt-3">
                                        <div className="col col-sm-1 col-md-1 col-lg-1">
                                            <agui.aToggleV4
                                                id="flAssicurazioneCongiunta"
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.ASSICURAZIONE_CONGIUNTA', 'Assicurazione Congiunta')}
                                                type="NO"
                                                disabled={false}
                                                // disabled=
                                                // {(this.props.location.state && (this.props.location.state.modifica || this.props.location.state.versione
                                                //     || this.props.location.state.clone))}
                                                value={this.props.prodotto.flAssicurazioneCongiunta}
                                                checked={this.props.prodotto.flAssicurazioneCongiunta}
                                                onChange={this.checkBoxChangeHandler}
                                            />
                                        </div>
                                    </div>
                                }

                                {this.props.prodotto.flAssicurazioneCongiunta === true &&
                                    <div>
                                        <div className="row mt-4">
                                            <div className="col col-sm-2 col-md-2 col-lg-2">
                                                <div
                                                // style={
                                                //     {
                                                //         marginTop: 30,
                                                //         // marginLeft: 85
                                                //     }
                                                // }
                                                >
                                                    <agui.aButton bs="primary" icon="fas fa-arrow-alt-circle-right" onClick={this.insertAssicurazioneCongiunta}>{i18n('ARM_CORE_PRODUCT.SHARED.INSERISCI', 'Inserisci')}</agui.aButton>
                                                </div>
                                            </div>

                                        </div>

                                        {this.props.prodotto.listaProdottoCmpPojo &&
                                            <table className="table table-bordered table-hover table-striped " >
                                                <thead>
                                                    <tr>
                                                        <td>Index</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PUNTO_VENDITA', 'Punto Vendita')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.NUMERO_POLIZZA', 'Numero Polizza')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA', 'Elimina')}</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.prodotto.listaProdottoCmpPojo.map(
                                                        (item, index) =>
                                                            (isNullOrUndefined(item.elimina) || item.elimina === false) &&
                                                            <tr key={index}>
                                                                <td style={{
                                                                    textAlign: 'center',
                                                                    verticalAlign: 'middle'
                                                                }} >{index + 1}</td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}>
                                                                    <agui.ASelectV4
                                                                        id={index}
                                                                        name="idCompagnia"
                                                                        required={false}
                                                                        onChange={this.arrayChangeHandlerCompagnie}
                                                                        value={item.prodottoCmp.idCompagnia
                                                                        }
                                                                        items={this.props.listCompagnie}

                                                                        valueKey="id"
                                                                        labelKey="denominazione"
                                                                    />
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}>
                                                                    {item.prodottoCmp.puntiVendita && item.prodottoCmp.puntiVendita.length > 0 ?
                                                                        <agui.ASelectV4
                                                                            name="idPuntoVendita"
                                                                            required={false}
                                                                            id={index}
                                                                            disabled={item.prodottoCmp.idCompagnia === undefined || item.prodottoCmp.idCompagnia === null ||
                                                                                item.prodottoCmp.idCompagnia === ""}
                                                                            onChange={this.arrayChangeHandlerCompagnie}
                                                                            value={item.prodottoCmp.idPuntoVendita
                                                                            }
                                                                            addEmptyOption={item.prodottoCmp.puntiVendita.length !== 1}
                                                                            items={item.prodottoCmp.puntiVendita}

                                                                            valueKey="id"
                                                                            labelKey="denominazione"
                                                                        />
                                                                        :
                                                                        i18n('ARM_CORE_PRODUCT.PRODOTTO.NESSUN_PUNTO_VENDITA_ASSOCIATO_ALLA_COMPAGNIA_SELEZIONATA', 'Nessun punto vendita associato alla compagnia. Vi preghiamo di crearne uno prima di procedere.')
                                                                    }



                                                                </td>
                                                                <td>
                                                                    <agui.ATextInputV4 id={index} type="text"
                                                                        value={item.prodottoCmp.numeroPolizza}
                                                                        label={i18n('ARM_CORE_PRODUCT.NUMERO_POLIZZA', 'Numero Polizza')}
                                                                        name="numeroPolizza"
                                                                        onChange={this.arrayChangeHandlerNumeroPolizza} />
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}> <agui.aButton bs="danger" id={index} icon="fas fa-trash-alt" onClick={() => this.removeSelectedRow(index)} ></agui.aButton> </td>
                                                            </tr>
                                                    )
                                                    }
                                                </tbody>
                                            </table>

                                        }
                                    </div>
                                }

                                {this.props.prodotto.coass === true &&

                                    <div>
                                        <div className="row mt-4">
                                            <div className="col col-sm-4 col-md-4 col-lg-4">
                                                <agui.ATextInputV4 id="quotaCoass" type="number"
                                                    value={this.props.prodotto.quotaCoass}
                                                    visible={this.props.prodotto.coass === undefined || this.props.prodotto.coass === null ||
                                                        this.props.prodotto.coass === false}
                                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.QUOTA_COASS', 'Quota Coass')}
                                                    placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTO.INSERIRE_QUOTA_COASS', 'inserire quotaCoass')}
                                                    onChange={this.inputChangeHandler} />
                                            </div>
                                            <div className="col col-sm-2 col-md-2 col-lg-2">
                                                <div
                                                    style={
                                                        {
                                                            marginTop: 30,
                                                            // marginLeft: 85
                                                        }
                                                    }
                                                >
                                                    <agui.aButton bs="primary" icon="fas fa-arrow-alt-circle-right" onClick={this.insertQuota}>{i18n('ARM_CORE_PRODUCT.SHARED.INSERISCI', 'Inserisci')}</agui.aButton>
                                                </div>
                                            </div>

                                        </div>





                                        {this.props.prodotto.listaProdottoCmpPojo &&
                                            <table className="table table-bordered table-hover table-striped " >
                                                <thead>
                                                    <tr>
                                                        <td>Index</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PUNTO_VENDITA', 'Punto Vendita')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.QUOTA', 'Quota')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.MANDATARIA', 'Mandataria')}</td>
                                                        <td>{i18n('ARM_CORE_PRODUCT.SHARED.ELIMINA', 'Elimina')}</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.props.prodotto.listaProdottoCmpPojo.map(
                                                        (item, index) =>
                                                            (isNullOrUndefined(item.elimina) || item.elimina === false) &&
                                                            <tr key={index}>
                                                                <td style={{
                                                                    textAlign: 'center',
                                                                    verticalAlign: 'middle'
                                                                }} >{index + 1}</td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}>
                                                                    <agui.ASelectV4
                                                                        id={index}
                                                                        name="idCompagnia"
                                                                        required={false}
                                                                        onChange={this.arrayChangeHandlerCompagnie}
                                                                        value={item.prodottoCmp.idCompagnia
                                                                        }
                                                                        items={this.props.listCompagnie}

                                                                        valueKey="id"
                                                                        labelKey="denominazione"
                                                                    />
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}>
                                                                    {item.prodottoCmp.puntiVendita && item.prodottoCmp.puntiVendita.length > 0 ?
                                                                        <agui.ASelectV4
                                                                            name="idPuntoVendita"
                                                                            required={false}
                                                                            id={index}
                                                                            disabled={item.prodottoCmp.idCompagnia === undefined || item.prodottoCmp.idCompagnia === null ||
                                                                                item.prodottoCmp.idCompagnia === ""}
                                                                            onChange={this.arrayChangeHandlerCompagnie}
                                                                            value={item.prodottoCmp.idPuntoVendita
                                                                            }
                                                                            addEmptyOption={item.prodottoCmp.puntiVendita.length !== 1}
                                                                            items={item.prodottoCmp.puntiVendita}

                                                                            valueKey="id"
                                                                            labelKey="denominazione"
                                                                        />
                                                                        :
                                                                        i18n('ARM_CORE_PRODUCT.PRODOTTO.NESSUN_PUNTO_VENDITA_ASSOCIATO_ALLA_COMPAGNIA_SELEZIONATA', 'Nessun punto vendita associato alla compagnia. Vi preghiamo di crearne uno prima di procedere.')
                                                                    }
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}>
                                                                    <agui.ATextInputV4 id={index} type="text"
                                                                        value={item.prodottoCmp.quotaCoass}
                                                                        label=""
                                                                        name="quotaCoass"
                                                                        onChange={this.arrayChangeHandlerCompagnie} />

                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}>
                                                                    <input type="checkbox"

                                                                        id={index}
                                                                        checked={item.prodottoCmp.flMandataria === true}
                                                                        onChange={this.flMandatariaChangeHandler}
                                                                    />
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        verticalAlign: 'middle'
                                                                    }}> <agui.aButton bs="danger" id={index} icon="fas fa-trash-alt" onClick={() => this.removeSelectedRow(index)} ></agui.aButton> </td>
                                                            </tr>
                                                    )
                                                    }
                                                </tbody>
                                            </table>

                                        }
                                    </div>
                                }
                                <div className="row mt-4">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                        {opt("APP", "FL_VIEW_TAB_RAMO", "false") === "true" &&
                                            <agui.ASelectV4
                                                id="idRamo"
                                                disabled={false}
                                                required={true}
                                                validation={this.state.validation}
                                                onChange={this.inputChangeHandler}
                                                value={this.props.prodotto.idRamo}
                                                label={i18n('ARM_CORE_PRODUCT.SHARED.RAMO_SINISTRI', 'Ramo')}
                                                items={this.props.ramoSinistri}
                                                valueKey="id"
                                                labelKey="idConDenominazioneRamo"
                                            />
                                        }
                                    </div>
                                </div>

                                {(this.props.prodotto.coass === undefined || this.props.prodotto.coass === null || this.props.prodotto.coass !== true) && (this.props.prodotto.flAssicurazioneCongiunta === undefined || this.props.prodotto.flAssicurazioneCongiunta === null || this.props.prodotto.flAssicurazioneCongiunta !== true) ?
                                    <div className="row mt-4">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <agui.ASelectV4
                                                id="idCompagnia"
                                                required={true}
                                                onChange={this.inputChangeHandlerCompagnia}
                                                value={this.props.prodotto.idCompagnia
                                                }
                                                validation={this.state.validation}
                                                disabled=
                                                {(this.props.location.state && this.props.location.state.modifica
                                                    && (!isNullOrUndefined(this.props.prodotto.numEmissioni)) && this.props.prodotto.numEmissioni > 0)}
                                                label={i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia')}
                                                items={this.props.listCompagnie}
                                                valueKey="id"
                                                labelKey="denominazione"
                                            />
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            {this.props.prodotto
                                                && this.props.prodotto.idCompagnia ?

                                                this.props.listaPuntiVenditaOfCompagnia
                                                    && this.props.listaPuntiVenditaOfCompagnia.length > 0 ?
                                                    <agui.ASelectV4
                                                        id="idPuntoVendita"
                                                        required={false}
                                                        // addEmptyOption={this.props.listaPuntiVenditaOfCompagnia.length !== 1}
                                                        onChange={this.inputChangeHandler}
                                                        value={this.props.prodotto.idPuntoVendita
                                                        }
                                                        validation={this.state.validation}
                                                        label={i18n('ARM_CORE_PRODUCT.PRODOTTO.PUNTO_VENDITA', 'Punto Vendita')}
                                                        items={this.props.listaPuntiVenditaOfCompagnia}
                                                        disabled={this.props.location.state && this.props.location.state.modifica
                                                            && !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0}
                                                        valueKey="id"
                                                        labelKey="denominazione"
                                                    />
                                                    :
                                                    <div style={
                                                        {
                                                            marginTop: 38,
                                                            marginLeft: 30
                                                        }
                                                    }>
                                                        <i aria-hidden="true" className='fa fa-exclamation-triangle '>

                                                            {i18n('ARM_CORE_PRODUCT.PRODOTTO.NESSUN_PUNTO_VENDITA_ASSOCIATO_ALLA_COMPAGNIA_SELEZIONATA', 'Nessun punto vendita associato alla compagnia. Vi preghiamo di crearne uno prima di procedere. ')}
                                                        </i>
                                                    </div>
                                                :
                                                null}
                                        </div>
                                    </div>
                                    : null}

                            </div>
                            <div className={this.props.tabSelected === "regola-tab" ? "tab-pane active" : "tab-pane fade"} id="regola" role="tabpanel" aria-labelledby="regola-tab">
                                <div className="row mt-4">
                                    <div className=" col-8 mt-4">

                                        <Editor
                                            textareaClassName="form-control-regola"
                                            // onChange={this.inputChangeHandler}
                                            value={this.props.prodotto.ruleJavascript}
                                            onValueChange={(value) => this.inputChangeHandler(
                                                {
                                                    target: {
                                                        value: value,
                                                        id: "ruleJavascript",
                                                        name: "ruleJavascript"
                                                    }
                                                }
                                            )}
                                            padding={30}
                                            highlight={(code) => this.props.prodotto.ruleJavascript ? Prism.highlight(this.props.prodotto.ruleJavascript, Prism.languages.javascript, 'javascript') : null}
                                            style={{
                                                width: "100%",
                                                fontFamily: '"Fira code", "Fira Mono", monospace',
                                                fontSize: 12,
                                                // border: "1px solid #ced4da !important",
                                                // borderRadius: ".25rem !important",
                                                // transition: "border-color .15s ease-in-out,box-shadow .15s ease-in-out !important",
                                            }} ></Editor>

                                    </div>

                                </div>
                            </div>
                            <div className={this.props.tabSelected === "garanzie-tab" ? "tab-pane active" : "tab-pane fade"} id="garanzie" role="tabpanel" aria-labelledby="garanzie-tab">

                                <div className="mt-4">
                                    {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                                        <agui.aButton className="float-right mr-2 mb-2" bs='primary' onClick={this.nuovaGaranziaButton} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVA', 'Nuova')}</agui.aButton>
                                    }
                                    <table style={{
                                        textAlign: 'center',
                                        verticalAlign: 'middle'
                                    }} className="table table-bordered table-hover table-striped" >
                                        <thead>
                                            <tr>
                                                <td>Id</td>
                                                <td>{i18n('ARM_CORE_PRODUCT.SHARED.GARANZIA', 'Garanzia')}</td>
                                                <td>{i18n('ARM_CORE_PRODUCT.SHARED.TIPO_COPERTURA', 'Tipo Copertura')}</td>
                                                {(this.props.prodotto.flProdottoSoluzione !== null && this.props.prodotto.flProdottoSoluzione !== undefined
                                                    && this.props.prodotto.flProdottoSoluzione == true) ?
                                                    <td>{i18n('ARM_CORE_PRODUCT.SHARED.PRODOTTO.BASE', 'Nome Prodotto Base')}</td>
                                                    : null
                                                }
                                                {(this.props.prodotto.flAssicurazioneCongiunta !== null && this.props.prodotto.flAssicurazioneCongiunta !== undefined
                                                    && this.props.prodotto.flAssicurazioneCongiunta === true) ?
                                                    <td>{i18n('ARM_CORE_PRODUCT.SHARED.PRODOTTO.LISTA.COMPAGNIE', 'Compagnie')}</td>
                                                    : null
                                                }
                                                <td>{i18n('ARM_CORE_PRODUCT.GARANZIE.SIGLA', 'Sigla')} Cmp</td>
                                                <td>{i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')} Cmp</td>
                                                {(this.props.prodotto.flProdottoSoluzione === null || this.props.prodotto.flProdottoSoluzione === undefined
                                                    || this.props.prodotto.flProdottoSoluzione == false) ?
                                                    <td>{i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info')} Cmp</td>
                                                    : null
                                                }



                                            </tr>
                                        </thead>
                                        <tbody >
                                            {prodottoGaranzia && prodottoGaranzia.map(
                                                (item, index) =>
                                                    <tr key={index}>
                                                        <td style={{
                                                            textAlign: 'center',
                                                            verticalAlign: 'middle'
                                                        }} >{prodottoGaranzia[index] ? prodottoGaranzia[index].prodottoGaranzia.idGaranzia : null}</td>
                                                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                            {prodottoGaranzia[index] ? (
                                                                isAuth('SHOW_SIGLA_GARANZIA_DETTAGLIO_PRODOTTO') ? (
                                                                    <>
                                                                        {prodottoGaranzia[index].garanzia.nome}
                                                                        <br></br>
                                                                        <em>{i18n('ARM_CORE_PRODUCT.GARANZIE.SIGLA', 'Sigla')}</em>: <strong>{prodottoGaranzia[index].garanzia.sigla}</strong>
                                                                    </>
                                                                ) : (
                                                                    <>{prodottoGaranzia[index].garanzia.nome}</>
                                                                )
                                                            ) : null}
                                                        </td>

                                                        <td>
                                                            <agui.ASelectV4
                                                                id={index}
                                                                disabled={false}
                                                                required={false}

                                                                onChange={this.arrayChangeHandler}
                                                                value={prodottoGaranzia[index] ? prodottoGaranzia[index].prodottoGaranzia.tipoCopertura : null}
                                                                label=""
                                                                items={domain("AI_TIPO_COPERTURA")}
                                                                name="tipoCopertura"
                                                                valueKey="valCampo"
                                                                labelKey="desDom"
                                                            />
                                                        </td>
                                                        {(this.props.prodotto.flProdottoSoluzione !== null && this.props.prodotto.flProdottoSoluzione !== undefined
                                                            && this.props.prodotto.flProdottoSoluzione == true)

                                                            ?
                                                            <td>
                                                                <agui.ASelectV4
                                                                    id={index}
                                                                    disabled={false}
                                                                    required={false}
                                                                    name="idProdottoBase"
                                                                    onChange={this.arrayChangeHandler}
                                                                    value={prodottoGaranzia[index] ? prodottoGaranzia[index].prodottoGaranzia.idProdottoBase : null}
                                                                    label=""
                                                                    items={prodottoGaranzia[index].prodottoGaranzia.prodottoBasePojo}
                                                                    valueKey="id"
                                                                    labelKey="nome"
                                                                />
                                                            </td>
                                                            :
                                                            null

                                                        }
                                                        {(this.props.prodotto.flAssicurazioneCongiunta !== null && this.props.prodotto.flAssicurazioneCongiunta !== undefined
                                                            && this.props.prodotto.flAssicurazioneCongiunta == true)

                                                            ?
                                                            <td>
                                                                <agui.ASelectV4
                                                                    id={index}
                                                                    disabled={false}
                                                                    required={false}
                                                                    name="idCompagnia"
                                                                    onChange={this.arrayChangeHandler}
                                                                    value={prodottoGaranzia[index] ? prodottoGaranzia[index].prodottoGaranzia.idCompagnia : null}
                                                                    label=""
                                                                    items={prodottoGaranzia[index].prodottoGaranzia.prodottoGaranzieCompagniePojo}
                                                                    valueKey="idCompagnia"
                                                                    labelKey="nomeCompagnia"
                                                                />
                                                            </td>
                                                            : null}

                                                        <td>
                                                            {/* {(prodottoGaranzia[index] !== undefined && prodottoGaranzia[index] !== null && prodottoGaranzia[index].prodottoGaranzia.tipoCopertura !== 'NP' && prodottoGaranzia[index].prodottoGaranzia.tipoCopertura !== 'DD') ? */}
                                                            <agui.ATextInputV4 id={index} type="text"
                                                                value={prodottoGaranzia[index] ? prodottoGaranzia[index].prodottoGaranzia.cmpGarSigla : null}
                                                                label=""
                                                                disabled={prodottoGaranzia[index] === undefined
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === undefined
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === null
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === "DD"
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === "NP"}
                                                                name="cmpGarSigla"
                                                                eventParam={item.cmpGarSigla}
                                                                onChange={this.arrayChangeHandler} />
                                                        </td>
                                                        <td>
                                                            {/* {(prodottoGaranzia[index] !== undefined && prodottoGaranzia[index] !== null && prodottoGaranzia[index].prodottoGaranzia.tipoCopertura !== 'NP' && prodottoGaranzia[index].prodottoGaranzia.tipoCopertura !== 'DD') ? */}
                                                            <agui.ATextInputV4 id={index} type="text"
                                                                value={prodottoGaranzia[index] ? prodottoGaranzia[index].prodottoGaranzia.cmpGarNome : null}
                                                                label=""
                                                                disabled={prodottoGaranzia[index] === undefined
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === undefined
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === null
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === "DD"
                                                                    || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === "NP"}
                                                                name="cmpGarNome"
                                                                eventParam={item.cmpGarNome}
                                                                onChange={this.arrayChangeHandler} />
                                                        </td>
                                                        {(this.props.prodotto.flProdottoSoluzione === null || this.props.prodotto.flProdottoSoluzione === undefined
                                                            || this.props.prodotto.flProdottoSoluzione == false) ?
                                                            <td>
                                                                {/* {(prodottoGaranzia[index] !== undefined && prodottoGaranzia[index] !== null && prodottoGaranzia[index].prodottoGaranzia.tipoCopertura !== 'NP' && prodottoGaranzia[index].prodottoGaranzia.tipoCopertura !== 'DD') ? */}
                                                                <textarea
                                                                    id={index}
                                                                    name="cmpGarInfo"
                                                                    disabled={prodottoGaranzia[index] === undefined
                                                                        || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === undefined
                                                                        || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === null
                                                                        || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === "DD"
                                                                        || prodottoGaranzia[index].prodottoGaranzia.tipoCopertura === "NP"}
                                                                    className="form-control"
                                                                    rows="3" cols="70"
                                                                    value={prodottoGaranzia[index] ? prodottoGaranzia[index].prodottoGaranzia.cmpGarInfo : null}
                                                                    onChange={this.arrayChangeHandler} />
                                                            </td>
                                                            : null
                                                        }


                                                    </tr>
                                            )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "intermediari-tab" ? "tab-pane active" : "tab-pane fade"} id="intermediari" role="tabpanel" aria-labelledby="intermediari-tab">
                                    <IntermediariTable source="prodottoCreate" resetSelected={this.props.resetSelected} inizializzaNuovoProdottoIntermediario={this.props.inizializzaNuovoProdottoIntermediario} rows={this.props.prodotto.listaProdottoIntermediarioPojo} prodotto={this.props.prodotto} inputChangeHandler={this.inputChangeHandlerIntermediario}></IntermediariTable>
                                </div>
                            }
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "provAttive-tab" ? "tab-pane active" : "tab-pane fade"} id="provAttive" role="tabpanel" aria-labelledby="provAttive-tab">
                                    <div className="row mt-4">
                                        <div className="col col-sm-4 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="dataInizio">  {i18n('ARM_CORE_PRODUCT.PRODOTTO.DATA_INIZIO', 'Data Inizio')} </label>
                                                <input className="form-control" type="date"
                                                    onChange={this.inputChangeHandlerProvvigioniFilters}
                                                    value={this.props.provvigioniFilters ? this.props.provvigioniFilters.dataInizio : ""}
                                                    id="dataInizio" name="dataInizio" />
                                            </div>

                                        </div>

                                        <div className="col col-sm-3 col-md-3 col-lg-3">
                                            <agui.ATextInputV4 id="percEmissione" type="number"
                                                value={this.props.provvigioniFilters ? this.props.provvigioniFilters.percEmissione : null}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_EMISSIONE', '% Emissione')}
                                                onChange={this.inputChangeHandlerProvvigioniFilters} />
                                        </div>
                                        <div className="col col-sm-3 col-md-3 col-lg-3">
                                            <agui.ATextInputV4 id="percRinnovo" type="number"
                                                value={this.props.provvigioniFilters ? this.props.provvigioniFilters.percRinnovo : null}
                                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_RINNOVO', '% Rinnovo')}
                                                onChange={this.inputChangeHandlerProvvigioniFilters} />
                                        </div>
                                        <div style={
                                            {
                                                marginTop: 30,
                                            }
                                        }
                                            className="col col-sm-2 col-md-2 col-lg-2">
                                            <agui.aButton bs="primary" icon="fas fa-arrow-alt-circle-right" onClick={this.applicaSuTuttiProvvigioniButton}>{i18n('ARM_CORE_PRODUCT.PRODOTTO.APPLICA_SU_TUTTE', 'APPLICA SU TUTTE')}</agui.aButton>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <table style={{
                                            textAlign: 'center',
                                            verticalAlign: 'middle'
                                        }} className="table table-bordered" >
                                            <thead>
                                                <tr>
                                                    <td>{i18n('', 'Punto Vendita')}</td>
                                                    <td>{i18n('ARM_CORE_PRODUCT.SHARED.GARANZIA', 'Garanzia')}</td>
                                                    <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.DATA_INIZIO', 'Data Inizio')}</td>
                                                    <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_EMISSIONE', '% Emissione')}</td>
                                                    <td>{i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_RINNOVO', '% Rinnovo')}</td>
                                                    {/* <td>Info Cmp</td> */}
                                                </tr>
                                            </thead>
                                            <tbody >
                                                {!this.props.prodotto.listaProvvigioniAttive || this.props.prodotto.listaProvvigioniAttive.length === 0 ?
                                                    i18n('ARM_CORE_PRODUCT.PRODOTTO.NESSUNA_GARANZIA_ASSOCIATA_AL_PRODOTTO', 'Nessuna garanzia di tipo copertura "Obbligatoria" o "Facoltativa" non è legata a questo prodotto ')
                                                    : this.props.prodotto.listaProvvigioniAttive.map(
                                                        (item, index) =>


                                                            < tr key={index} >
                                                                <td style={{
                                                                    textAlign: 'center',
                                                                    verticalAlign: 'middle'
                                                                }} >{item.puntoVendita.denominazione}</td>
                                                                <td style={{
                                                                    textAlign: 'center',
                                                                    verticalAlign: 'middle'
                                                                }}>{item.garanzia ? item.garanzia.nome : null}</td>
                                                                <td style={{
                                                                    textAlign: 'center',
                                                                    verticalAlign: 'middle'
                                                                }}>
                                                                    <input className="form-control" type="date"
                                                                        onChange={this.arrayChangeHandlerProvvigioni}
                                                                        value={item.prodottoGaranziaProvvigioni ? DateFormatter.formatDateFromMilisToString(item.prodottoGaranziaProvvigioni.dataInizio) : ""}
                                                                        id={index} name="dataInizio" />
                                                                </td>

                                                                <td>
                                                                    <agui.ATextInputV4 id={index} type="number"
                                                                        value={item.prodottoGaranziaProvvigioni ? item.prodottoGaranziaProvvigioni.percEmissione : null}
                                                                        label=""
                                                                        disabled={item.prodottoGaranziaProvvigioni.id !== undefined && item.prodottoGaranziaProvvigioni.id !== null}
                                                                        name="percEmissione"
                                                                        eventParam={item.percEmissione}
                                                                        onChange={this.arrayChangeHandlerProvvigioni} />

                                                                </td>
                                                                <td>
                                                                    <agui.ATextInputV4 id={index} type="text"
                                                                        value={item.prodottoGaranziaProvvigioni ? item.prodottoGaranziaProvvigioni.percRinnovo : null}
                                                                        label=""
                                                                        disabled={item.prodottoGaranziaProvvigioni.id !== undefined && item.prodottoGaranziaProvvigioni.id !== null}
                                                                        name="percRinnovo"
                                                                        eventParam={item.percRinnovo}
                                                                        onChange={this.arrayChangeHandlerProvvigioni} />

                                                                </td>
                                                            </tr>
                                                    )}
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            }
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "frazionamenti-tab" ? "tab-pane active" : "tab-pane fade"} id="frazionamenti" role="tabpanel" aria-labelledby="frazionamenti-tab">
                                    <FrazionamentiTable source="prodottoCreate" frazionamenti={this.props.frazionamenti} inzializzaModificaFrazionamenti={this.props.inzializzaModificaFrazionamenti}></FrazionamentiTable>
                                </div>
                            }
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "pagamenti-tab" ? "tab-pane active" : "tab-pane fade"} id="pagamenti" role="tabpanel" aria-labelledby="pagamenti-tab">
                                    <PagamentoTable source="prodottoCreate" pagamenti={this.props.pagamenti} inzializzaModificaPagamenti={this.props.inzializzaModificaPagamenti}></PagamentoTable>
                                </div>
                            }
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "sinistri-tab" ? "tab-pane active" : "tab-pane fade"} id="sinistri" role="tabpanel" aria-labelledby="sinistri-tab">
                                    <ProdottoSinistri prodotto={this.props.prodotto} source="prodottoCreate" sinistri={sinistri} onChange={this.props.inputChangeHandlerSinistri}></ProdottoSinistri>
                                </div>
                            }
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "operazioni-tab" ? "tab-pane active" : "tab-pane fade"} id="operazioni" role="tabpanel" aria-labelledby="operazioni-tab">
                                    <OperazioniTable source="prodottoCreate" operazioni={this.props.operazioni} inzializzaModificaOperazioni={this.props.inzializzaModificaOperazioni}></OperazioniTable>
                                </div>
                            }
                            {this.props.location.state && this.props.location.state.modifica &&
                                opt("APP", "FL_VIEW_TAB_DURATA", "false") === "true" &&
                                <div className={this.props.tabSelected === "durata-tab" ? "tab-pane active" : "tab-pane fade"} id="durataA" role="tabpanel" aria-labelledby="durata-tab">
                                    <DurataTable source="prodottoCreate" durataA={this.props.durataA} inzializzaModificaDurata={this.props.inzializzaModificaDurata}></DurataTable>
                                </div>
                            }

                            {this.props.location.state && this.props.location.state.modifica &&
                                opt("APP", "FL_VIEW_PRODOTTO_TAB_SCONTO", "false") === "true" &&
                                <div className={this.props.tabSelected === "sconto-tab" ? "tab-pane active" : "tab-pane fade"} id="sconto" role="tabpanel" aria-labelledby="sconto-tab">
                                    <ScontoTable source="prodottoCreate" listaSconto={this.props.listaSconto} inzializzaModificaSconto={this.props.inzializzaModificaSconto}></ScontoTable>
                                </div>
                            }
                            {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTO_TAB_SERVIZIO_ESTERN') && this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "servizioEsterno-tab" ? "tab-pane active" : "tab-pane fade"} id="servizioEsterno" role="tabpanel" aria-labelledby="servizioEsterno-tab">
                                    <ProdottoServiziEsterni validation={this.state.validation} source="prodottoCreate"></ProdottoServiziEsterni>
                                </div>
                            }

                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "firmaDigitale-tab" ? "tab-pane active" : "tab-pane fade"} id="firmaDigitale" role="tabpanel" aria-labelledby="firmaDigitale-tab">
                                    <FirmaDigitale validation={this.state.validation} source="prodottoCreate"></FirmaDigitale>
                                </div>
                            }
                            {this.props.location.state && this.props.location.state.modifica &&
                                <div className={this.props.tabSelected === "regolaAnnulli-tab" ? "tab-pane active" : "tab-pane fade"} id="regolaAnnulli" role="tabpanel" aria-labelledby="regolaAnnulli-tab">
                                    <RegolaProduct source="prodottoCreate"></RegolaProduct>
                                </div>
                            }

                        </div>
                    </agui.aCardV4Body>
                    <agui.aCardFooter>
                        <div>
                            <agui.aButton bs="primary" className="mr-2" icon="fas fa-save" onClick={this.showConfirmPanel}>{i18n('ARM_CORE_PRODUCT.SHARED.SALVAA', 'Salva')}</agui.aButton>
                            <agui.aButton bs="secondary" className="float-right mr-2" onClick={this.annullaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}</agui.aButton>
                        </div>
                    </agui.aCardFooter>
                </agui.aCardV4>


                <ConfirmModalSaveV4
                    testoTitle={i18n('ARM_CORE_PRODUCT.SALVA', 'Salva')}
                    testoBody={this.props.testoBody !== undefined && this.props.testoBody !== null ? this.props.testoBody : i18n('ARM_CORE_PRODUCT.CONFERMI_DI.VOLER.SALV', 'Confermi di voler salvare?')}
                    testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SALVA', 'Salva')}
                    testoButtonCancel={i18n('ARM_CORE_PRODUCT.SHARED.ANNULLA', 'Annulla')}
                    show={this.state.showConfirm}
                    saveOnClick={this.salvaOnClickProdottoCreate}
                    onClose={this.showConfirmPanel} />


                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDelete}
                    deleteOnClick={this.deleteProdottoImmagine}
                    onClose={this.showConfirmPanelElimina} />

                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDeleteDoc}
                    deleteOnClick={this.deleteDocument}
                    onClose={this.showConfirmDocumentElimina} />
            </div >

        );
    }
};
function mapStateToProps(state) {
    return {
        prodotto: state.prodotto.detailsProdotto,
        listaProdottoIntermediarioPojo: state.prodotto.listaProdottoIntermediarioPojo,
        listCompagnie: state.prodotto.listCompagnie,
        listaPuntiVenditaOfCompagnia: state.prodotto.listaPuntiVenditaOfCompagnia,
        provvigioniFilters: state.prodotto.provvigioniFilters,
        tabSelected: state.prodotto.tabSelected,
        prodottoPadre: state.prodotto.detailsProdotto.prodottoPadre,
        frazionamenti: state.prodotto.frazionamenti,
        pagamenti: state.prodotto.pagamenti,
        operazioni: state.prodotto.operazioni,
        prodottoServiziEsterni: state.prodotto.prodottoServiziEsterni,
        microCategorie: state.microCategorie.detailsMC,
        durataA: state.prodotto.durataA,
        listaSconto: state.prodotto.listaSconto,
        listaSegnelatori: state.prodotto.listaSegnelatori,
        prodottoFirmaDigitale: state.prodotto.prodottoFirmaDigitale,
        ramoSinistri: state.microCategorie.ramoSinistri,
    }
}

function mapDispatchToProps(dispatch) {
    return {

        salvaProdotto(history, isClone, idProdottoSorgente) {
            return dispatch(ProdottoActions.salvaProdotto(history, isClone, idProdottoSorgente));
        },
        handleChange(index, e) {
            return dispatch(ProdottoActions.handleChange(index, e))
        },
        updateProdottoGaranzia(name, index, value) {
            return dispatch(ProdottoActions.updateProdottoGaranzia(name, index, value))

        },
        getListCompagnie() {
            return dispatch(ProdottoActions.getListCompagnie())
        },
        getListaPuntiVenditaOfCompagnia(idCompagnia) {
            return dispatch(ProdottoActions.getListaPuntiVenditaOfCompagnia(idCompagnia))
        },
        handleChangeProdottoCmp(index, e) {
            return dispatch(ProdottoActions.handleChangeProdottoCmp(index, e))
        },
        insertQuota() {
            return dispatch(ProdottoActions.insertQuota())
        },
        updateProdottoCompagnia(name, index, value) {
            return dispatch(ProdottoActions.updateProdottoCompagnia(name, index, value));
        },
        updateItemsPuntoVendita(index, value) {
            return dispatch(ProdottoActions.updateItemsPuntoVendita(index, value));
        },
        removeSelectedCompagnia(index) {
            return dispatch(ProdottoActions.removeSelectedCompagnia(index))
        },
        updateFlMandataria(name, index, value) {
            return dispatch(ProdottoActions.updateFlMandataria(name, index, value));
        },
        calcolaQuaotaCoass() {
            return dispatch(ProdottoActions.calcolaQuaotaCoass());
        },
        changeSelectedTab(idTab) {
            return dispatch(ProdottoActions.changeSelectedTab(idTab));
        },
        setFlEliminaCompagnia(index) {
            return dispatch(ProdottoActions.setFlEliminaCompagnia(index))
        },
        inizializzaNuovaGaranziaDalProdotto() {
            return dispatch(GaranzieActions.inizializzaNuovaGaranziaDalProdotto())
        },
        inizializzaMicroCategorieProdotto() {
            return dispatch(ProdottoActions.inizializzaMicroCategorieProdotto())
        },
        inzializzaModificaFrazionamenti() {
            return dispatch(ProdottoActions.inzializzaModificaFrazionamenti())
        },
        inzializzaModificaPagamenti() {
            return dispatch(ProdottoActions.inzializzaModificaPagamenti())
        },
        inputChangeHandlerSinistri(id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerSinistri(id, value))
        },
        inputChangeHandlerIntermediario(index, id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerIntermediario(index, id, value))
        },
        inizializzaNuovoProdottoIntermediario(index) {
            return dispatch(ProdottoActions.inizializzaNuovoProdottoIntermediario(index))
        },

        resetSelected(index, wasSelected) {
            return dispatch(ProdottoActions.resetSelected(index, wasSelected))
        },
        inzializzaModificaOperazioni() {
            return dispatch(ProdottoActions.inzializzaModificaOperazioni())
        },
        salvaProdottoServiziEsterni(history) {
            return dispatch(ProdottoActions.salvaProdottoServiziEsterni(history))
        },
        deleteProdottoImmagine() {
            return dispatch(ProdottoActions.deleteProdottoImmagine())
        },
        quotationJSON() {
            return dispatch(ProdottoActions.quotazioneJSON())
        },
        getMicroCategorieDetails(gpId) {
            return dispatch(MicroCategorieActions.getMicroCategorieDetails(gpId));
        },
        inzializzaModificaDurata() {
            return dispatch(ProdottoActions.inzializzaModificaDurata())
        },
        inzializzaModificaSconto() {
            return dispatch(ProdottoActions.inzializzaModificaSconto())
        },
        // getProdottoBaseDetailsdiMicrocategoria(idMicroCategoria) {
        //     return dispatch(MicroCategorieActions.getProdottoBaseDetailsdiMicrocategoria(idMicroCategoria));
        // },
        downloadDocument(path) {
            return dispatch(app_actions.downloadDocument(path))
        },
        deleteDocument(idDocument) {
            return dispatch(ProdottoActions.deleteDocument(idDocument))
        },
        deleteProdottoDocumentTipoExcel() {
            return dispatch(ProdottoActions.deleteProdottoDocumentTipoExcel())
        },
        getProdottoDetails(id) {
            return dispatch(ProdottoActions.getProdottoDetails(id))
        },
        insertAssicurazioneCongiunta() {
            return dispatch(ProdottoActions.insertAssicurazioneCongiunta())
        },
        updateProdottoCmpNumeroPolizza(name, index, value) {
            return dispatch(ProdottoActions.updateProdottoCmpNumeroPolizza(name, index, value))
        },
        getListaSegnelatori() {
            return dispatch(ProdottoActions.getListaSegnelatori());
        },
        salvaProdottoFirmaDigitale(history) {
            return dispatch(ProdottoActions.salvaProdottoFirmaDigitale(history));
        },
        getListaRamoSinistri() {
            return dispatch(MicroCategorieActions.getListaRamoSinistri());
        },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateProdotto);